module.exports = __webpack_public_path__ + "img/04.24fa95bb.png";